import React from 'react';
import { object, bool } from 'prop-types';
import Paper from '@material-ui/core/Paper';

// Text of a landing page (App_Data/landing-pages.json on the server), shown below the tool:
// the intro and steps beside the questions, whose answers open on click. The answers stay in
// the page, so search engines still read them. The strings are ours and may contain links, so
// they are rendered as HTML.
const LandingContent = ({ page, nightModeEnabled }) => {
  const color = nightModeEnabled ? '#ffffff' : 'rgba(0, 0, 0, 0.87)';
  const muted = nightModeEnabled ? '#cccccc' : '#4A5468';
  const rule = nightModeEnabled ? '1px solid #444444' : '1px solid #DDDDDD';
  const html = text => ({ __html: text });

  return (
    <Paper
      style={{
        marginTop: 20,
        padding: '18px 24px',
        color,
        lineHeight: 1.5,
        fontSize: 14,
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '16px 40px'
      }}
    >
      <div>
        {page.intro && <p style={{ marginTop: 0 }} dangerouslySetInnerHTML={html(page.intro)} />}
        {page.howTo && (
          <>
            <h2 style={{ fontSize: 16, fontWeight: 500, margin: '0 0 6px' }}>How to use it</h2>
            <ol style={{ margin: 0, paddingLeft: 20 }}>
              {page.howTo.map((step, i) => (
                <li key={i} dangerouslySetInnerHTML={html(step)} />
              ))}
            </ol>
          </>
        )}
      </div>
      {page.faq && (
        <div>
          <h2 style={{ fontSize: 16, fontWeight: 500, margin: '0 0 6px' }}>Questions</h2>
          {page.faq.map((item, i) => (
            <details
              key={i}
              style={{ borderTop: rule, borderBottom: i === page.faq.length - 1 ? rule : 'none' }}
            >
              <summary style={{ cursor: 'pointer', padding: '8px 0', fontWeight: 500 }}>
                {item.q}
              </summary>
              <p
                style={{ margin: '0 0 10px', color: muted }}
                dangerouslySetInnerHTML={html(item.a)}
              />
            </details>
          ))}
        </div>
      )}
    </Paper>
  );
};

LandingContent.propTypes = {
  page: object.isRequired,
  nightModeEnabled: bool
};

export default LandingContent;
